import React, { useMemo } from "react";
import { renderAvatar } from "@/lib/avatar2d";
import { botCharacter } from "@/lib/avatarConfig";

// A bot's picture: the head and shoulders of its raider (Jack, 2026-10-18),
// in place of the robot icon bots used to show.
const FACE_VIEWBOX = "16 6 168 168";

// A raider's head and shoulders as an SVG string.
export function raiderFaceSvg(look) {
  return renderAvatar(look, { pose: "face" })
    .replace(/viewBox="[^"]*"/, `viewBox="${FACE_VIEWBOX}"`)
    .replace("<svg ", '<svg style="width:100%;height:100%;display:block" ');
}

export function botFaceSvg(name) {
  return raiderFaceSvg(botCharacter(name).look);
}

export default function BotFace({ name, className = "" }) {
  const svg = useMemo(() => botFaceSvg(name), [name]);
  return (
    <span
      className={`relative inline-block rounded-full overflow-hidden flex-none bg-muted ${className}`}
      data-testid="bot-face"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
